import React from 'react';
import LoadingSpinner from './loading-spinner';
import styled from '@emotion/styled/macro';
import { LoadingSpinnerProps } from './loading-spinner.types';

const LoadingSpinnerImgContainer: React.FC<LoadingSpinnerProps> = ({
  className,
}) => {
  return (
    <div className={className}>
      <LoadingSpinner />
    </div>
  );
};

const StyledLoadingSpinnerImgContainer = styled(LoadingSpinnerImgContainer)`
  display: flex;
  flex-direction: row;
  align-items: center;
  align-content: center;
  transition: none !important;
  height: 100%;
  div,
  svg {
    transition: none !important;
    & * {
      transition: none !important;
    }
  }
`;

export default StyledLoadingSpinnerImgContainer;
